import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './MissionListPage.scss'

const MissionListPage = () => {
	return (
		<div className="main-content missions-page">
			<GamificationBlock
				domId={WIDGETS.missionsPage.domId}
				url={WIDGETS.missionsPage.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default MissionListPage
